import { useProductTechSheetsListForEditQuery } from 'api/hooks'
import { getLocaleId, LOCALES_TO_EXCLUDE } from 'utils/getLocaleId'

export interface TechSheet {
  id: string
  localeId: number
  locale: string
  name: string
}

const excludeLocales = <T extends { locale: string }>(items: T[]): T[] =>
  items.filter(item => !LOCALES_TO_EXCLUDE.includes(item?.locale))

export const useTechSheetsList = (productId: string | null) => {
  const { data } = useProductTechSheetsListForEditQuery({
    variables: { id: productId ?? '', localeId: getLocaleId() },
    skip: !productId,
    fetchPolicy: 'cache-and-network',
  })

  const wineId = data?.product?.wine?.id

  const techSheets = excludeLocales(
    (data?.product?.wine?.techSheets ?? []).map(
      (item): TechSheet => ({
        id: item.id,
        localeId: item?.locale?.id,
        locale: item?.locale?.locale,
        name: item?.locale?.localizedName,
      })
    )
  )

  const totalLocalesCount = excludeLocales(data?.locales ?? []).length

  return {
    wineId,
    techSheets,
    totalLocalesCount,
  }
}
